// Module
var code = `<div class="row">
    <div class="col-lg-12">
        <bfg-chart name="video.VideoCountGrowingByMissions"></bfg-chart>
    </div>
</div>

<installs-table rows="rows" prec="3" rebuild-columns-on-change="true"></installs-table>
`;
// Exports
module.exports = code;